export default {
	'total-quantity': 'Cantidad total'
}